$(document).ready(function() {
    $(".select-nav #page_link").change((event) => {
        let $target = $(event.target);
        let url = $target.val();
        if(url){
            window.location = url;
        }
    })
});